
import makerjs from "makerjs";
function C09(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  // console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    R1 = Param[0].param,R2 = Param[1].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       r1 = R1 * 1 * myZoom,r2 = R2 * 1 * myZoom,       
    //    h = H * 1 * myZoom,
     h=r2,w=2*r2,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       rd2=r2/Math.sqrt(2),
       x0=0,y0=0,x1=r2,y1=r2,x2=2*r2,y2=0,x3=2*r2-r1,y3=0,x4=r2,y4=r1,x5=r2-r1,y5=0,glassH = h, glassW = w;

       if (r1 !== 0) {
        var TxtR1 = "R1="+R1;
    }if (r2 !== 0) {
        var TxtR2 = "R2="+R2;
    }
   var drawAbnormalShapeC09 = {
       paths: {
        "ArcLineBig": new makerjs.paths.Arc([x0,y0], [x1,y1],[x2,y2]),
        "BottomLineLeft": new makerjs.paths.Line([x2,y2], [x3,y3]),
        "ArcLineSmall": new makerjs.paths.Arc([x3,y3], [x4,y4],[x5,y5]),
        "BottomLineRight": new makerjs.paths.Line([x5,y5], [x0,y0]),
       }
   };
   var drawAbnormalShapeC09MarkR2 = {
    paths: {
     "Line": new makerjs.paths.Line([w/2, 0], [w/2+rd2, rd2]),
    }
};
var drawAbnormalShapeC09MarkR1 = {
    paths: {
     "Line": new makerjs.paths.Line([w/2, 0], [w/2, r1]),
    }
};
    makerjs.model.addCaption(drawAbnormalShapeC09MarkR1, TxtR1, [w/2+2*markShift, 0], [w/2+2*markShift, r1]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeC09MarkR2, TxtR2, [w/2+rd2, rd2+markShift], [w/2+rd2+2*markShift, rd2+markShift]);//长度文字  
   
  plate={
    models: {
      drawAbnormalShapeC09: drawAbnormalShapeC09,
      }
    };
    markers={
      models: {
        drawAbnormalShapeC09: drawAbnormalShapeC09,
        drawAbnormalShapeC09MarkR2: drawAbnormalShapeC09MarkR2,
        drawAbnormalShapeC09MarkR1: drawAbnormalShapeC09MarkR1,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C09;